module.exports = __webpack_public_path__ + "static/media/fill_58@2x.42b094ec.png";